import React from 'react'
import { Button } from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'
import { useSurface } from '../../hooks/usePermission'

/**
 * "Manage rooms" on the Rooms page (SC-422). Creating and managing a company's rooms needs
 * rooms.manage (Owner and Admin by default, platform admins always); the server checks it too
 * (SC-439).
 */
export function ManageRoomsButton({
  companyId,
  onClick,
}: {
  companyId: string | undefined
  onClick: () => void
}) {
  const canManageRooms = useSurface('rooms-page.manage-rooms')
  if (!canManageRooms || !companyId) return null
  return (
    <Button
      variant="contained"
      startIcon={<SettingsIcon />}
      onClick={onClick}
      data-testid="manage-rooms"
    >
      Manage rooms
    </Button>
  )
}
